import AuthService from "../../helpers/auth"
import References from "../../helpers/Reference"

export const loadStationsMCHReport = () => {
    return AuthService.fetch(References.api.report_mch_station).then(res => res.json())
}

export const loadStationSheetReport = () => {
    return AuthService.fetch(References.api.report_sheet_station).then(res => res.json())
}

export const loadPrecipitationHolders = () => {
    return AuthService.fetch(References.api.report_precipitation_holders).then(res => res.json())
}

export const searchStation = (stations, search) => {
    const result = [];
    const keys = Object.keys(stations);
    keys.forEach(key => {
        if (stations[key].name.includes(search)) {
            //дополняем uuid
            const ready = stations[key]
            ready.uuid = key;
            result.push(ready)
        }
    })
    return result
}

export const extractUUIDSFromHolders = (data) => {
    const result = []
    Object.keys(data).forEach(uuid => {
        result.push(uuid)
        if (data[uuid].hasOwnProperty('children'))
            Object.keys(data[uuid]?.children).forEach(childIdx => {
                result.push(Object.keys(data[uuid].children[childIdx])[0])
            })
    })
    return result
}

export const getHolderChildrens = (holders, holder) => {
    if (holders.hasOwnProperty(holder) && holders[holder].hasOwnProperty('children')) {
        return (Object.keys(holders[holder].children).map(child => {
            return Object.keys(holders[holder].children[child])[0]
        }))
    }
    return [];
}